import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import sessionstorage from "redux-persist/lib/storage/session";
import indexDBstorage from 'redux-persist-indexeddb-storage';
import { persistReducer, persistStore, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";
// import thunk from 'redux-thunk';
import loginSlice from "./features/login/loginSlice";
import configurationSlice from "./features/common/configurationSlice";
import apicommunicationSlice from "./features/common/apicommunicationSlice";
import combinedataSlice from "./features/common/combinedataSlice";
import ARBSlice from "./features/common/ARBSlice";
import smartDevicesSlice from "./features/common/SmartDevicesSlice";


const ConfigurationReducerpersistConfigLocal = {
    key: 'configurationSlice',
    storage: storage,
}

const LoginpersistConfigSession = {
    key: 'loginSlice',
    storage: sessionstorage,
}


const apicommunicationConfigSession = {
    key: 'apicommunicationSlice',
    storage: sessionstorage,
}


const combinedataSession = {
    key: 'combinedataSlice',
    storage: indexDBstorage("combinedDB"),
}

const ARBSession = {
    key: 'ARBSlice',
    storage: sessionstorage,
}

const SmartDevicesDataSession = {
    key: 'smartDevicesSlice',
    storage: indexDBstorage("SmartDevicesDataDB"),
}

const LoginReducer = persistReducer(LoginpersistConfigSession, loginSlice)
const ConfigurationReducer = persistReducer(ConfigurationReducerpersistConfigLocal, configurationSlice)
const apicommunicationReducer = persistReducer(apicommunicationConfigSession, apicommunicationSlice)
const combinedataReducer = persistReducer(combinedataSession, combinedataSlice)
const ARBReducer = persistReducer(ARBSession, ARBSlice)
const SmartDevicesReducer = persistReducer(SmartDevicesDataSession, smartDevicesSlice)

const rootReducer = combineReducers({
    login: LoginReducer,
    configuration: ConfigurationReducer,
    apicommunication: apicommunicationReducer,
    combinedata:combinedataReducer,
    ARB:ARBReducer,
    SmartDevices: SmartDevicesReducer

})

export const store = configureStore({
    name:"WMRMS",
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>{
        return getDefaultMiddleware({
        serializableCheck: {
            ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
        })
    }
});

export const persistor = persistStore(store);
export const mainstore = store;

